import { render, staticRenderFns } from "./NewsDeleteDialog.vue?vue&type=template&id=2275c3f2&"
import script from "./NewsDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./NewsDeleteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports